import { render, staticRenderFns } from "./AmbulansLaporanPage.vue?vue&type=template&id=ca97911a"
import script from "./AmbulansLaporanPage.vue?vue&type=script&lang=js"
export * from "./AmbulansLaporanPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports